import { computed } from 'vue'
import { defineRouter } from '#q-app/wrappers'
import { createMemoryHistory, createRouter, createWebHashHistory, createWebHistory, useRoute } from 'vue-router'

import { LocalStorage } from 'quasar'
import routes from './routes'
import { setCountryCode } from 'boot/i18n'
import { useAccountStore } from 'src/stores/account'
import countries from 'src/assets/countries.json'

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

// Redirect hash to history
if (
  window.location.hash &&
  (window.location.hash.match(/^#?\/([\w-]+)\/booking\/\d+.*/) || window.location.hash.includes('?biz='))
) {
  const path = window.location.hash.startsWith('#') ? window.location.hash.substring(1) : window.location.hash
  console.log('Redirecting hash to history:', window.location.hash, '->', path)
  window.location.replace(path)
}

export default defineRouter(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
      ? createWebHistory
      : createWebHashHistory

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  })

  Router.beforeEach((to, from) => {
    console.log(`Navigation: ${from.fullPath} -> ${to.fullPath}`)
    console.log(`Query params - from: ${JSON.stringify(from.query)}, to: ${JSON.stringify(to.query)}`)
    console.log(`Route params - from: ${JSON.stringify(from.params)}, to: ${JSON.stringify(to.params)}`)

    if (to.query.cc) {
      setCountryCode(to.query.cc.toString())
    }
    if (to.params.countryCode) {
      setCountryCode(to.params.countryCode.toString())
    }
    if (to.meta.requiresAuth && !useAccountStore().isLoggedIn) {
      console.log('Auth redirect triggered')
      return {
        name: 'login',
        params: { countryCode: to.params.countryCode },
        query: { redirect: to.fullPath },
        replace: true,
      }
    }

    if (from.query.biz && !to.query.biz) {
      console.log('Preserving biz parameter:', from.query.biz)
      return { ...to, query: { ...to.query, biz: from.query.biz }, replace: true }
    }
  })

  return Router
})

export function useCountry() {
  const route = useRoute()
  return computed(() => {
    const fromRoute = route.params.countryCode
      ? countries.find(({ code }) => code === route.params.countryCode)
      : undefined
    if (fromRoute) return fromRoute
    const stored = LocalStorage.getItem('country_code')
    if (stored && countries.some(({ code }) => code === stored)) {
      return countries.find(({ code }) => code === stored)
    }
    return undefined
  })
}

export function useArea() {
  const route = useRoute()
  const country = useCountry()
  return computed(() => {
    return country.value?.areas.find(({ name }) => name === route.params.area)
  })
}
